import React from 'react'
import AttributeList from '../components/products/AttributeList'

function AttributesPage() {
  return (
    <div className='attributes'>
        <AttributeList/>
    </div>
  )
}

export default AttributesPage